import { SET_PAY_RATES_TYPE, SET_PAY_RATES_DATA, SET_PAY_RATE, SET_PAY_RATES_STAFF_DATA } from '../../actions/types/types';

const initialState = {
  payRatesType: {},
  payRates: [],
  payrate: {},
  payRatesStaff: [],
  payrollOverview:[],
  payrollDetails:{}
};

const payRollReducer = (state = initialState, action) => {
  switch (action.type) {
    case SET_PAY_RATES_TYPE:
      return {
        ...state,
        payRatesType: action.payload.data,
      };
    case SET_PAY_RATES_DATA:
      return {
        ...state,
        payRates: action.payload.data,
      };
    case SET_PAY_RATE:
      return {
        ...state,
        payrate: action.payload.data,
      };
    case SET_PAY_RATES_STAFF_DATA:
      return {
        ...state,
        payRatesStaff: action.payload.data,
      };
    case "SET_PAYROLL_OVERVIEW":  
          return {
        ...state,
        payrollOverview: action.payload.data,
      };
    case "SET_PAYROLL_DETAILS"  :
          return {
        ...state,
        payrollDetails: action.payload.data,
      };
    default:
      return state;
  }
};

export default payRollReducer;
